const React = require('react')
const { useState, useEffect } = require('react')
const { useLocation } = require('react-router-dom')
const { Container, Col, Row } = require('reactstrap')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { TableHeader, TableFooter } = require('@components/table')
const { NFTsTable } = require('./table.nfts')

require('@styles/pages/blocks/index.css')

const NFTs = () => {
    const location = useLocation()
    const { network } = useNetworkConfig()
    const { getNfts } = useBlockchainData(network.name)

    const params = new URLSearchParams(location.search)

    const [page, setPage] = useState(Number(params.get('p')) || 1)
    const [limit, setLimit] = useState(Number(params.get('ps')) || 25)
    const [nftsData, setNftsData] = useState()

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const pageParam = Number(params.get('p'))
        const limitParam = Number(params.get('ps'))

        if (pageParam && pageParam > 0 && pageParam !== page) {
            setPage(pageParam)
        }

        if (limitParam && limitParam > 0 && limitParam !== limit) {
            setLimit(limitParam)
        }
    }, [location.search])

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)

            try {
                const [nftsResponse] = await Promise.all([getNfts(page, limit)])

                if (nftsResponse) {
                    setNftsData(nftsResponse)
                }
            } catch (error) {
                console.error('Error fetching data:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [network, page, limit])

    return (
        <div className='page'>
            <Container>
                <Col>
                    <Row>
                        <div className='page-header'>
                            <text className='page-title'>Top NFTs</text>
                            <div className='page-title-border' />
                        </div>
                    </Row>

                    <div className='box table-section' style={{ padding: '24px 24px 0' }}>
                        {loading ? (
                            <div
                                className='d-flex justify-content-center align-items-center'
                                style={{ height: '300px' }}
                            >
                                <LoadingSpinner />
                            </div>
                        ) : (
                            <>
                                <TableHeader
                                    title={`A total of ${nftsData?.totalItems.toLocaleString()} NFT Collections found`}
                                    subtitle={`Showing ${nftsData?.totalItems.toLocaleString()} NFT Collections with OK or Neutral Reputation`}
                                    page={page}
                                    limit={limit}
                                    totalPages={nftsData?.totalPages}
                                />
                                <NFTsTable data={nftsData?.items} />
                                <TableFooter
                                    limit={limit}
                                    setLimit={setLimit}
                                    page={page}
                                    setPage={setPage}
                                    totalPages={nftsData?.totalPages}
                                />
                            </>
                        )}
                    </div>
                </Col>
            </Container>
        </div>
    )
}

module.exports = NFTs
